<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "bc-panel-slot",
  render() {
    return this.$slots.default;
  },
};
</script>